import { Flex, Stack, Link, Text, useColorModeValue } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'

import { SITE_URL } from '@/constants'
import { EnvelopeIcon } from '@/components/icons/EnvelopeIcon'
import { FacebookIcon } from '@/components/icons/FacebookIcon'
import { LinkedinIcon } from '@/components/icons/LinkedinIcon'
import { RedditIcon } from '@/components/icons/RedditIcon'
import { XIcon } from '@/components/icons/XIcon'

interface ShareProps {
  url: string
  justifyContent?: string
}

export const Share = ({ url, justifyContent }: ShareProps) => {
  const t = useTranslations()
  const articleUrl = `${SITE_URL}${url}`

  return (
    <Flex
      alignItems="center !important"
      justifyContent={justifyContent}
      position={{ base: 'sticky', md: 'fixed' }}
      right={{ base: 'auto', md: '0' }}
      top={{ base: 'auto', md: '50%' }}
      bottom={{ base: 0, md: 'auto' }}
      transform={{ base: 'none', md: 'translateY(-50%)' }}
      zIndex={100}
    >
      <Stack
        direction={{ base: 'row', md: 'column' }}
        spacing="4"
        padding={{ base: 3, md: 2 }}
        bg={useColorModeValue('blackAlpha.800', 'whiteAlpha.800')}
        rounded="lg"
        align="center"
        justifyContent="center"
        boxShadow="lg"
        backdropFilter="blur(10px)"
      >
        <Text
          m="0 !important"
          fontSize="sm"
          fontWeight="bold !important"
          color={useColorModeValue('white', 'black')}
        >
          {t('common.share')}
        </Text>
        <Link
          href={`https://x.com/intent/tweet?url=${articleUrl}`}
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
          display="flex"
          alignItems="center"
        >
          <XIcon h="6" w="auto" color={useColorModeValue('white', 'black')} />
        </Link>

        <Link
          href={`https://www.facebook.com/sharer.php?u=${articleUrl}`}
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
          display="flex"
          alignItems="center"
        >
          <FacebookIcon
            h="6"
            w="auto"
            color={useColorModeValue('white', 'black')}
          />
        </Link>
        <Link
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${articleUrl}`}
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
          display="flex"
          alignItems="center"
        >
          <LinkedinIcon
            h="6"
            w="auto"
            color={useColorModeValue('white', 'black')}
          />
        </Link>
        <Link
          href={`https://www.reddit.com/submit?url=${articleUrl}`}
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
          display="flex"
          alignItems="center"
        >
          <RedditIcon
            h="6"
            w="auto"
            color={useColorModeValue('white', 'black')}
          />
        </Link>
        <Link
          href={`mailto:?body=${articleUrl}`}
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
          display="flex"
          alignItems="center"
        >
          <EnvelopeIcon
            h="6"
            w="auto"
            color={useColorModeValue('white', 'black')}
          />
        </Link>
      </Stack>
    </Flex>
  )
}
